import React, { useCallback } from 'react';
import { withAnimatedNavigationHeader } from 'design-system';
import { logDeleteDetails } from './analytics';
import FeatureIssueScrollView from './components/FeatureIssueScrollView';
import useNavigateAfterIssueStep from './hooks/useNavigateAfterIssueStep';
const DeleteFeatureIssueScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const navigateAfterIssueStep = useNavigateAfterIssueStep();
    const onPressFeature = useCallback((name) => {
        navigateAfterIssueStep();
        logDeleteDetails('delete', name, 'Features');
    }, [navigateAfterIssueStep]);
    const onPressBack = useCallback(() => {
        navigation.popToTop();
    }, []);
    return (<FeatureIssueScrollView onPressFeature={onPressFeature} onPressBack={onPressBack} scrollHandler={scrollHandler}/>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default DeleteFeatureIssueScreen;
